import { useState } from "react";

function useColumnVisibilityTour() {
    const [runTour, setRunTour] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);

    const steps = [
        {
            target: '.column-visibility-dialog',
            title: 'Column Visibility & Ordering',
            content: 'This dialog allows you to customize which columns are visible in your table and change their display order.',
            disableBeacon: true,
            placement: 'center',
        },
        {
            target: '.dialog-search input',
            title: 'Search Columns',
            content: 'Use this search box to quickly find specific columns by name.',
            disableBeacon: true,
        },
        {
            target: '.dialog-actions',
            title: 'Quick Actions',
            content: 'Use these buttons to quickly show or hide all columns at once.',
            disableBeacon: true,
        },
        {
            target: '.column-row:first-child .drag-handle',
            title: 'Drag Handle',
            content: 'Click and hold this handle to drag a column up/down to a new position.',
            disableBeacon: true,
        },
        {
            target: '.column-row:first-child .checkbox-container',
            title: 'Show/Hide Column',
            content: 'Check or uncheck this box to show or hide the column in your table view.',
            disableBeacon: true,
        },
        {
            target: '.dialog-footer',
            title: 'Save or Cancel',
            content: 'Click "Apply" to save your changes, or "Cancel" to discard them and close the dialog.',
            disableBeacon: true,
        },
    ];

    const handleStartTutorial = () => {
        setRunTour(false);
        setStepIndex(0);
        
        setTimeout(() => {
            // Filter out steps whose elements don't exist in DOM
            const availableSteps = steps.filter(step => {
                const element = document.querySelector(step.target);
                return element !== null;
            });

            if (availableSteps.length === 0) {
                console.warn('No tour elements found in DOM');
                return;
            }

            setStepIndex(0);
            setRunTour(true);
        }, 100);
    };

    const handleJoyrideCallback = (data) => {
        const { status, action, type, index } = data;
        console.log("Joyride callback data: ", data);

        // Handle error status (when element not found)
        if (status === 'error') {
            console.warn('Tour error - element not found, trying next step');
            const nextIndex = index + 1;
            if (nextIndex < steps.length) {
                setStepIndex(nextIndex);
                return;
            } else {
                setRunTour(false);
                setStepIndex(0);
                return;
            }
        }

        // Handle all closing actions consistently
        if (status === 'finished' || status === 'skipped') {
            console.log("Tour ended with status:", status);
            setRunTour(false);
            setStepIndex(0);
            return;
        }
        
        // Treat 'close' action the same as 'stop'
        if (action === 'close' || action === 'stop') {
            console.log("Tour stopped/closed with action:", action);
            setRunTour(false);
            setStepIndex(0);
            return;
        }
        
        if (type === 'step:after' && action === 'next') {
            setStepIndex(index + 1);
        } else if (type === 'step:after' && action === 'prev') {
            let targetIndex = index - 1;

            if (targetIndex < 0) {
                setRunTour(false);
                setStepIndex(0);
                return;
            }

            setStepIndex(targetIndex);
        }
    };

    return {
        runTour,
        stepIndex,
        steps,
        handleStartTutorial,
        handleJoyrideCallback,
    };
}

export default useColumnVisibilityTour;